import type { ReactNode } from 'react';
import {
  COMPETITION_ADDABLE_CATALOG,
  COMPETITION_FAMILIES,
  COMPETITION_FAMILY_ORDER,
  COMPETITION_FILTER_INDEX,
  type CompetitionFilterKey,
} from './competitionFilterCatalog';
import { FilterMenu, type FilterMenuEntry, type FilterMenuFamily } from './FilterMenu';

interface CompetitionAddFilterMenuProps {
  activeKeys: Set<CompetitionFilterKey>;
  availableKeys: Set<CompetitionFilterKey>;
  onAddFilter: (key: CompetitionFilterKey) => void;
}

const FAMILIES: FilterMenuFamily[] = COMPETITION_FAMILY_ORDER.map((familyId) => ({
  id: familyId,
  label: COMPETITION_FAMILIES[familyId].label,
  tone: COMPETITION_FAMILIES[familyId].tone,
}));

export function CompetitionAddFilterMenu({
  activeKeys,
  availableKeys,
  onAddFilter,
}: CompetitionAddFilterMenuProps): ReactNode {
  const entries: FilterMenuEntry[] = COMPETITION_ADDABLE_CATALOG.filter((definition) =>
    availableKeys.has(definition.key),
  ).map((definition) => ({
    key: definition.key,
    label: definition.label,
    icon: definition.icon,
    family: definition.family,
  }));

  const disabledReason = (key: string): string | null => {
    const dependsOn = COMPETITION_FILTER_INDEX[key as CompetitionFilterKey]?.dependsOn;
    if (dependsOn === undefined || activeKeys.has(dependsOn)) return null;
    return `Add the ${COMPETITION_FILTER_INDEX[dependsOn].label} filter first`;
  };

  return (
    <FilterMenu
      families={FAMILIES}
      entries={entries}
      activeKeys={activeKeys}
      disabledReason={disabledReason}
      onAdd={(key) => onAddFilter(key as CompetitionFilterKey)}
    />
  );
}
